import "./style.css";
import layout from "./layout.html";

export default class Text {
  static selector = ".text";

  constructor(
    block,
    {
      title,
      paragraph,
      largeTitle = false,
      horizontal = false,
      separator = false,
      clamp = true,
      largeParagraph = false,
      mediumParagraph = false,
    }
  ) {
    this.block = block;

    this.title = title;
    this.paragraph = paragraph;
    this.largeTitle = largeTitle;
    this.horizontal = horizontal;
    this.separator = separator;
    this.clamp = clamp;
    this.largeParagraph = largeParagraph;
    this.mediumParagraph = mediumParagraph;

    this.block.innerHTML = layout;

    this.titleNode = this.block.querySelector(".text__title");
    this.paragraphNode = this.block.querySelector(".text__paragraph");
  }

  setup = async () => {
    return new Promise(async (resolve) => {
      if (this.horizontal) {
        this.block.classList.add(`text--horizontal`);
      }

      if (this.separator) {
        this.block.classList.add("text--separator");
      }

      if (this.title) {
        this.titleNode.innerHTML = this.title;

        if (this.largeTitle) {
          this.titleNode.classList.add("homage", "p6", "uppercase");
        } else {
          this.titleNode.classList.add("p7");
        }
      } else {
        this.titleNode.remove();
      }

      if (this.paragraph) {
        this.paragraphNode.innerHTML = this.paragraph;
      } else {
        this.paragraphNode.remove();
      }

      if (this.clamp) {
        this.block.classList.add("text--clamp");
      }

      if (this.largeParagraph) {
        this.block.classList.add("text--large-paragraph");
      }

      if (this.mediumParagraph) {
        this.block.classList.add("text--medium-paragraph");
      }
      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
